<template>
  <div class="table-responsive text-nowrap">
    <a-table
      :columns="columns"
      :row-key="data.id"
      :data-source="data"
      :pagination="false"
      :loading="loading"
    >
      <template #businessUnit="{text}">
        {{ text.businessUnit.code }} - {{ text.businessUnit.name }}
      </template>
      <template #action="{text}">
        <a-button
          @click="$emit('openModal', text)"
          class="btn btn-sm btn-light mr-2"
        >
          <i class="fe fe-edit mr-2" />
          Editar
        </a-button>
        <a-button
          @click="$emit('softDelete', text)"
          class="btn btn-sm btn-outline-danger mr-2"
        >
          <i class="fe fe-trash mr-2" />
          Eliminar
        </a-button>
      </template>
    </a-table>
  </div>
</template>

<script>

const columns = [
  {
    title: 'Código de Planta',
    dataIndex: 'code',
    class: 'text-center',
  },
  {
    title: 'Nombre de Planta',
    dataIndex: 'name',
    class: 'text-center',
  },
  {
    title: 'Unidad de Negocio',
    dataIndex: '',
    slots: { customRender: 'businessUnit' },
    class: 'text-center',
  },
  {
    title: 'Acciones',
    slots: { customRender: 'action' },
    class: 'text-center',
  },
]

export default {
  name: 'PlantTable',
  props: {
    // eslint-disable-next-line vue/require-default-prop
    data: {
      type: [Object],
      require: true,
      defaultValue: {},
    },
    // eslint-disable-next-line vue/require-default-prop
    loading: {
      type: [Boolean],
      require: true,
      defaultValue: false,
    },
  },
  emits: [
    'openModal', 'softDelete',
  ],
  setup() {
    return {
      columns,
    }
  },
}
</script>

<style scoped>
</style>
